<template>
    <div >
         <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="添加时间" prop="addtime" fixed min-width="200"></el-table-column>
            <el-table-column label="添加人" prop="addusername" min-width="200"></el-table-column>
            <el-table-column class="leixing" label="类型" prop="type" width="200">
                <template slot-scope="scope">
                   <div v-if="scope.row.type==='thzbxm'">招标项目退回</div>
                   <div v-if="scope.row.type==='thxm'">项目退回</div>
                   <div v-if="scope.row.type==='thzbbd'">招标标段退回</div>
                   <div v-if="scope.row.type==='thzbwj'">招标文件退回</div>
                   <div v-if="scope.row.type==='thzbgg'">招标公告退回</div>
                   <div v-if="scope.row.type==='thexfkbjl'">二信封开标记录退回</div>
                   <div v-if="scope.row.type==='thkbjl'">开标记录退回</div>
                   <div v-if="scope.row.type==='thzgsc'">资格审查退回</div>
                   <div v-if="scope.row.type==='thpbbg'">评标报告退回</div>
                   <div v-if="scope.row.type==='thdbbg'">定标报告退回</div>
                   <div v-if="scope.row.type==='thzbxhr'">中标候选人退回</div>
                   <div v-if="scope.row.type==='thzbhxrgs'">中标候选人公示退回</div>
                   <div v-if="scope.row.type==='thzhongbiaogg'">中标公告退回</div>
                </template>
            </el-table-column>
            <el-table-column label="操作结果" width="100" fixed="right">
                <template slot-scope="scope">
                   <div v-if="scope.row.error==='1'"> 成功</div>
                   <div v-if="scope.row.error==='0'">失败</div>
                </template>
            </el-table-column>
        </my-table>
       <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('mngUrl')}/Zbdl/tuihui/loglist.json`">
        </my-pagination>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
       mixins: [LIST_PAGE_MIXIN],
    data() {
     return{
         pgData: {
                sortname: 'addtime',
                sortorder: 'desc',
                pagesize: 20,
            },
     }
    },
    computed: {
        
    },
    watch: {
    
    },
    methods: {
   
    created() {
                             
    },
    mounted() {
        
    }
}
}
</script>

<style scoped lang="scss">

</style>
